import { render } from "./ChildAdd.vue?vue&type=template&id=828f13fa&scoped=true&ts=true"
import script from "./ChildAdd.vue?vue&type=script&lang=ts"
export * from "./ChildAdd.vue?vue&type=script&lang=ts"

import "./ChildAdd.vue?vue&type=style&index=0&id=828f13fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828f13fa"]])

export default __exports__